import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IForgotPasswordResetResponse } from '../../../entity/interface/iAuthApis';

export interface IForgotPasswordResetUseCase {
    execute(
        username: string,
        pinValue: string,
        verifyGuid: string,
        password: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IForgotPasswordResetResponse>;
}

export class ForgotPasswordResetUseCase implements IForgotPasswordResetUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        pinValue: string,
        verifyGuid: string,
        password: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IForgotPasswordResetResponse> {
        return await this.authRepo.forgotPasswordReset(
            username,
            pinValue,
            verifyGuid,
            password,
            apiToken,
            recaptchaToken
        );
    }
}
